import { useSyncExternalStore } from "react";
import { emptyProgress, parseProgress, type Progress } from "./progress";
import { evaluateAchievements } from "./achievements";

export const STORAGE_KEY = "claude-cert-prep:progress:v1";

type Listener = () => void;

function load(): Progress {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? parseProgress(JSON.parse(raw)) : emptyProgress();
  } catch {
    return emptyProgress();
  }
}

let state: Progress = typeof localStorage === "undefined" ? emptyProgress() : load();
const listeners = new Set<Listener>();
/** Huy hiệu vừa mở khóa — để UI hiển thị toast. */
let unlockedQueue: string[] = [];

function persist(): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Hết quota hoặc chế độ riêng tư: vẫn chạy trong bộ nhớ.
  }
}

function emit(): void {
  for (const l of listeners) l();
}

export const progressStore = {
  get: (): Progress => state,
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  update(fn: (p: Progress) => Progress): void {
    const next = fn(state);
    if (next === state) return;
    const { progress, unlocked } = evaluateAchievements(next, Date.now());
    state = progress;
    if (unlocked.length) unlockedQueue = [...unlockedQueue, ...unlocked];
    persist();
    emit();
  },
  replace(p: Progress): void {
    state = p;
    persist();
    emit();
  },
  reset(): void {
    state = { ...emptyProgress(), theme: state.theme, lang: state.lang };
    persist();
    emit();
  },
  /** Đồng bộ lại từ localStorage (dùng cho sự kiện storage giữa các tab, và test). */
  reload(): void {
    state = load();
    emit();
  },
  takeUnlocked(): string[] {
    const q = unlockedQueue;
    unlockedQueue = [];
    return q;
  },
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY) progressStore.reload();
  });
}

export function useProgress(): Progress {
  return useSyncExternalStore(progressStore.subscribe, progressStore.get, progressStore.get);
}
